/* klaasje-stores
   De kaart op de verkooppuntenpagina. Leest de verkooppunten uit de lijst
   in de HTML (naam, adres, coördinaten, links), zet ze als pin op een
   Leaflet-kaart en koppelt lijst en kaart aan elkaar: een klik op een pin
   of een regel kiest dat verkooppunt, de kaart vliegt erheen en toont
   naam, adres, route en de link naar Google Maps.

   Zonder Leaflet (geblokkeerd, offline) doet dit niets en blijft de lijst
   met zijn links gewoon staan. */
(function () {
  if (customElements.get('klaasje-store-map')) return;

  // De standaardkaart van OpenStreetMap, zonder sleutel. (CARTO's lichte
  // stijl tekent sinds kort "API KEY REQUIRED" over elke tegel.)
  // Naamsvermelding is een voorwaarde.
  const TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  const ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
  const ZOOM_STORE = 15;

  // ── Openingstijden ──────────────────────────────────────────────
  // Het blok schrijft zeven dagen weg, maandag eerst, gescheiden door |.
  // Een dag is "08:00 - 22:00", "gesloten" of leeg (onbekend).
  const DAGEN = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  // Nu in Nederlandse tijd, ongeacht waar de bezoeker is: de zaak staat
  // in Amsterdam, niet de telefoon.
  function nuInNederland() {
    const delen = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach((d) => (delen[d.type] = d.value));
    return { dag: DAGEN.indexOf(delen.weekday), minuut: parseInt(delen.hour, 10) * 60 + parseInt(delen.minute, 10) };
  }

  function leesDag(tekst) {
    const t = (tekst || '').trim();
    if (!t) return null;
    if (/gesloten|dicht/i.test(t)) return { dicht: true, tekst: t };
    const m = t.match(/(\d{1,2})[:.](\d{2})\s*(?:-|–|tot)\s*(\d{1,2})[:.](\d{2})/);
    if (!m) return { tekst: t };
    const open = +m[1] * 60 + +m[2];
    let sluit = +m[3] * 60 + +m[4];
    // Sluiten na middernacht: 11:00 - 01:00 loopt door tot 25:00.
    if (sluit <= open) sluit += 1440;
    const pad = (n) => String(n).padStart(2, '0');
    return {
      open,
      sluit,
      van: `${pad(+m[1])}:${m[2]}`,
      tot: `${pad(+m[3])}:${m[4]}`,
    };
  }

  // { regel: 'Vandaag 08:00 - 22:00', open: true|false|null } of null als
  // er niets bekend is.
  function vandaag(item) {
    const dagen = (item.dataset.hours || '').split('|');
    if (dagen.every((d) => !d.trim())) return null;
    const { dag, minuut } = nuInNederland();
    const nu = leesDag(dagen[dag]);
    const gisteren = leesDag(dagen[(dag + 6) % 7]);

    // Nog open van gisteravond (een café tot 01:00).
    if (gisteren && gisteren.sluit > 1440 && minuut < gisteren.sluit - 1440) {
      return { regel: `Open tot ${gisteren.tot}`, open: true };
    }
    if (!nu) return null;
    if (nu.dicht) return { regel: 'Vandaag gesloten', open: false };
    if (nu.open === undefined) return { regel: `Vandaag ${nu.tekst}`, open: null };
    const open = minuut >= nu.open && minuut < nu.sluit;
    return { regel: `Vandaag ${nu.van} - ${nu.tot}`, open };
  }

  function tijdenHtml(info) {
    const wrap = document.createElement('span');
    if (info.open !== null) {
      const status = document.createElement('span');
      status.className = 'klaasje-stores__status ' + (info.open ? 'is-open' : 'is-closed');
      status.textContent = info.open ? 'Nu open' : 'Nu gesloten';
      wrap.appendChild(status);
    }
    const regel = document.createElement('span');
    regel.className = 'klaasje-stores__hours';
    regel.textContent = info.regel;
    wrap.appendChild(regel);
    return wrap;
  }

  class KlaasjeStoreMap extends HTMLElement {
    connectedCallback() {
      if (this.kaartKlaar) return;
      // De tijden werken ook als de kaart niet laadt.
      this.vulTijden();
      // De scrollbalk en het doorgeven van de veeg ook: de lijst staat op
      // zichzelf, met of zonder kaart.
      this.bouwBalk();
      this.doorgeefGebaar();
      // Leaflet laadt met defer vóór dit script, maar als de CDN faalt
      // bestaat L niet en blijft de lijst op zichzelf staan.
      if (!window.L) return;

      this.kaartEl = this.querySelector('[data-klaasje-stores-map]');
      this.lijstEl = this.querySelector('[data-klaasje-stores-list]');
      this.punten = [];
      if (!this.kaartEl || !this.lijstEl) return;

      this.bouwKaart();
      this.kaartKlaar = true;
    }

    vulTijden() {
      this.querySelectorAll('[data-klaasje-store]').forEach((item) => {
        const plek = item.querySelector('[data-klaasje-store-today]');
        const info = vandaag(item);
        if (!plek || !info) return;
        plek.replaceChildren(...tijdenHtml(info).childNodes);
        plek.hidden = false;
      });
    }

    // ── De scrollbalk van de lijst ────────────────────────────────
    // Een eigen balk, want iOS toont die van het scrollgebied alleen
    // tijdens het vegen: op een telefoon staan er drie verkooppunten in
    // beeld en dan is dit het enige wat verraadt dat er meer zijn.
    bouwBalk() {
      const lijst = this.querySelector('[data-klaasje-stores-list]');
      const houder = this.querySelector('[data-klaasje-stores-listwrap]');
      const duim = this.querySelector('[data-klaasje-stores-thumb]');
      if (!lijst || !houder || !duim) return;

      this.balk = { lijst, houder, duim };
      const teken = () => this.tekenBalk();
      lijst.addEventListener('scroll', teken, { passive: true });
      window.addEventListener('resize', teken);
      // Nohemi en Alte Haas komen later binnen en verzetten de hoogte van
      // elk item, dus de balk klopt pas na het laden van de letters.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(teken);
      teken();
    }

    tekenBalk() {
      const { lijst, houder, duim } = this.balk;
      const spoor = lijst.clientHeight;
      const inhoud = lijst.scrollHeight;
      // Een paar pixels speling: afronding van de browser mag geen balk
      // opleveren boven een lijst die gewoon past.
      const scrollbaar = inhoud - spoor > 4;
      houder.classList.toggle('is-scrollable', scrollbaar);
      if (!scrollbaar) return;

      const hoog = Math.max(28, Math.round((spoor * spoor) / inhoud));
      const y = Math.round((spoor - hoog) * (lijst.scrollTop / (inhoud - spoor)));
      duim.style.setProperty('--klaasje-stores-thumb-h', hoog + 'px');
      duim.style.setProperty('--klaasje-stores-thumb-y', y + 'px');
    }

    // ── De veeg doorgeven aan de pagina ───────────────────────────
    // iOS geeft een veeg die in een scrollgebied begint niet door aan de
    // pagina: stond je bovenaan de lijst, dan kwam je alleen nog langs
    // de rand van het scherm omhoog, want daar ligt de lijst niet.
    // overscroll-behavior verandert daar niets aan, dus doen we het
    // zelf: staat de lijst aan de grens waar de vinger heen wil, dan
    // nemen we het gebaar over en schuiven we de pagina 1:1 mee.
    doorgeefGebaar() {
      const lijst = this.querySelector('[data-klaasje-stores-list]');
      if (!lijst) return;

      let vorigeY = 0;
      lijst.addEventListener(
        'touchstart',
        (e) => {
          vorigeY = e.touches[0].clientY;
        },
        { passive: true }
      );

      // Niet passief: alleen zo mag preventDefault de lijst tegenhouden.
      lijst.addEventListener(
        'touchmove',
        (e) => {
          if (e.touches.length !== 1) return;
          // Scrolt de lijst helemaal niet (desktop, of maar een paar
          // verkooppunten), dan blijven we eraf: de browser doet de
          // pagina beter zelf, met uitloop en al.
          if (lijst.scrollHeight - lijst.clientHeight < 2) return;

          const y = e.touches[0].clientY;
          const dy = y - vorigeY;
          vorigeY = y;
          if (!dy) return;

          // Vinger omlaag (dy > 0) wil omhoog in de inhoud.
          const boven = lijst.scrollTop <= 0;
          const onder = lijst.scrollTop + lijst.clientHeight >= lijst.scrollHeight - 1;
          if ((dy > 0 && boven) || (dy < 0 && onder)) {
            e.preventDefault();
            window.scrollBy(0, -dy);
          }
        },
        { passive: false }
      );
    }

    bouwKaart() {
      const L = window.L;
      const fijn = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.kaart = L.map(this.kaartEl, {
        zoomControl: false,
        // Met een muis zou het scrollwiel de pagina kapen zodra je over de
        // kaart scrolt. Pas na een klik op de kaart zoomt het wiel.
        scrollWheelZoom: false,
        attributionControl: true,
      });
      L.control.zoom({ position: 'bottomright' }).addTo(this.kaart);
      L.tileLayer(TILES, {
        attribution: ATTRIBUTION,
        maxZoom: 19,
      }).addTo(this.kaart);

      if (fijn) {
        this.kaart.on('click focus', () => this.kaart.scrollWheelZoom.enable());
        this.kaartEl.addEventListener('mouseleave', () => this.kaart.scrollWheelZoom.disable());
      }

      const icoon = L.divIcon({
        className: 'klaasje-stores__pin',
        html: '<span class="klaasje-stores__pin-dot"></span>',
        iconSize: [34, 34],
        iconAnchor: [17, 34],
        popupAnchor: [0, -30],
      });

      this.lijstEl.querySelectorAll('[data-klaasje-store]').forEach((item) => {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);
        const punt = { item, marker: null };
        this.punten.push(punt);

        const pick = item.querySelector('[data-klaasje-store-pick]');
        if (pick) pick.addEventListener('click', () => this.kies(punt, { vanLijst: true }));

        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        punt.marker = L.marker([lat, lng], {
          icon: icoon,
          title: item.querySelector('.klaasje-stores__name')?.textContent || '',
          riseOnHover: true,
        }).addTo(this.kaart);
        punt.marker.bindPopup(() => this.popupInhoud(item), {
          closeButton: true,
          autoPanPadding: [24, 24],
          className: 'klaasje-stores__popup',
          // Op een telefoon is de kaart smaller dan 280 plus de ruimte die
          // autoPan nodig heeft; dan viel het kruisje buiten de kaart.
          maxWidth: Math.max(180, Math.min(280, this.kaartEl.clientWidth - 80)),
        });
        punt.marker.on('click', () => this.kies(punt, { vanLijst: false }));
        punt.marker.on('popupclose', () => {
          if (this.actief === punt) this.zetActief(null);
        });
      });

      this.passend();
      // De kaart staat in een grid die pas na de fonts zijn maat heeft.
      window.addEventListener('load', () => {
        this.kaart.invalidateSize();
        if (!this.actief) this.passend();
      });
    }

    // Alle pins in beeld.
    passend() {
      const pins = this.punten.filter((p) => p.marker).map((p) => p.marker.getLatLng());
      if (!pins.length) {
        this.kaart.setView([52.37, 4.89], 11);
      } else if (pins.length === 1) {
        this.kaart.setView(pins[0], ZOOM_STORE);
      } else {
        this.kaart.fitBounds(window.L.latLngBounds(pins), { padding: [48, 48], maxZoom: ZOOM_STORE });
      }
    }

    // Naam, adres en de twee links uit de lijst, zodat er maar één plek is
    // waar ze staan.
    popupInhoud(item) {
      const wrap = document.createElement('div');
      wrap.className = 'klaasje-stores__popup-inner';
      const naam = item.querySelector('.klaasje-stores__name');
      const soort = item.querySelector('.klaasje-stores__kind');
      const adres = item.querySelector('.klaasje-stores__address');
      const links = item.querySelector('[data-klaasje-store-links]');
      if (naam) {
        const h = document.createElement('p');
        h.className = 'klaasje-stores__popup-name';
        h.textContent = naam.textContent;
        wrap.appendChild(h);
      }
      if (soort) {
        const s = document.createElement('p');
        s.className = 'klaasje-stores__popup-kind';
        s.textContent = soort.textContent;
        wrap.appendChild(s);
      }
      if (adres) {
        const a = document.createElement('p');
        a.className = 'klaasje-stores__popup-address';
        a.textContent = adres.textContent;
        wrap.appendChild(a);
      }
      // Opnieuw uitgerekend en niet gekopieerd: de popup kan een uur na
      // het laden opengaan.
      const info = vandaag(item);
      if (info) {
        const t = document.createElement('p');
        t.className = 'klaasje-stores__today klaasje-stores__popup-today';
        t.append(...tijdenHtml(info).childNodes);
        wrap.appendChild(t);
      }
      if (links) {
        const l = links.cloneNode(true);
        l.className = 'klaasje-stores__popup-links';
        l.removeAttribute('data-klaasje-store-links');
        const route = l.querySelector('.klaasje-stores__route');
        if (route) route.classList.add('klaasje-btn');
        wrap.appendChild(l);
      }
      return wrap;
    }

    kies(punt, { vanLijst }) {
      this.zetActief(punt);
      if (!punt.marker) return;

      if (vanLijst) {
        // Op een smal scherm staat de kaart boven de lijst: eerst de kaart
        // in beeld, anders gebeurt er iets wat je niet ziet.
        const rect = this.kaartEl.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--klaasje-header-space')) || 88;
          window.scrollTo({ top: window.scrollY + rect.top - header, behavior: 'smooth' });
        }
        const doel = punt.marker.getLatLng();
        const opZoom = Math.max(this.kaart.getZoom(), ZOOM_STORE);
        this.kaart.flyTo(doel, opZoom, { duration: 0.8 });
        this.kaart.once('moveend', () => punt.marker.openPopup());
      } else {
        this.scrollLijstNaar(punt.item);
      }
    }

    zetActief(punt) {
      if (this.actief) {
        this.actief.item.classList.remove('is-active');
        this.actief.marker?.getElement()?.classList.remove('is-active');
      }
      this.actief = punt;
      if (punt) {
        punt.item.classList.add('is-active');
        punt.marker?.getElement()?.classList.add('is-active');
      }
    }

    // Alleen de lijst zelf scrollen, niet de pagina: scrollIntoView zou de
    // hele pagina meenemen.
    scrollLijstNaar(item) {
      const lijst = this.lijstEl;
      if (lijst.scrollHeight <= lijst.clientHeight) return;
      // De lijst staat op position: relative, dus offsetTop telt vanaf de lijst.
      const top = item.offsetTop - 12;
      lijst.scrollTo({ top, behavior: 'smooth' });
    }
  }

  customElements.define('klaasje-store-map', KlaasjeStoreMap);
})();
